<div class="main-container">
  <div class="dialog-body">
    <div class="dialog-align">
      <img src="../../assets/Alert_box/error_icon.svg">
    </div>
    <h2 class="message">Uh-oh, looks like you're not supposed to be here. If you think that's a mistake, please contact support@joymo.tv</h2>
    <img src="../../assets/Alert_box/close_icon.svg" class="close-dialog" mat-dialog-close>
  </div>
</div>